import { useState } from 'react';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { useLazyGetImportersQuery } from '../../../../../../services/contactsV2';

export const useContactOfFilter = ({ setFilters }) => {
  const [getImporters] = useLazyGetImportersQuery();
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formSchema = Yup.object().shape({
    importerIds: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      }),
    ),
  });

  const onSubmit = ({ importerIds }) => {
    setFilters({ importerIds });
  };

  const onMenuOpen = () => {
    if (options.length === 0) {
      setIsLoading(true);
      getImporters()
        .unwrap()
        .then((data) => {
          const formattedOptions = data?.importers?.map((item) => ({ label: item.name, value: item.id })) || [];
          setOptions(formattedOptions);
        })
        .catch(() => {
          setOptions([]);
          toast('Failed to load contact owners', {
            icon: 'danger',
            id: 'failed-to-load-contact-owners',
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return {
    formSchema,
    options,
    isLoading,
    onMenuOpen,
    onSubmit,
  };
};
